module.exports = __webpack_public_path__ + "static/media/ski.85e4c48b.webp";